import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

class Footer extends React.Component {
  render() {
    return (
      <>
        <footer className="py-3">
          <Container>
            <Row className="align-items-center justify-content-xl-between">
              <Col xl="12">
                <div className="copyright text-center text-muted">
                  © {(new Date().getFullYear())}
                  <a
                    className="font-weight-bold ml-1"
                    href="https://www.csjsistemas.com.br/"
                    target="_blank"
                  >
                    Desenvolvido por CSJ Sistemas
                  </a>
                </div>
              </Col>
              </Row>
          </Container>
        </footer>
      </>
    );
  }
}

export default Footer;
